export const BRAND_NAME = 'Sky11';
export const BRAND_DOMAIN = 'sky11.com';
export const BRAND_DOMAIN_SKIN_URL = 'sky11.com';
export const PROVIDER_ID = 'BetFair';
